import { hasFreeImageRouting, subscribeFreeImageRoutingRoots } from "./free-image-rollout-routing";
import { createContext, useSyncExternalStore, type ReactNode } from "react";
import { useFeatureSettings } from "../use-feature-settings";

export const ImageValidationRenderingContext = createContext(false);
export const FreeImageRoutingRenderingContext = createContext(false);

/** One feature-setting subscription per root; no DOM or user-facing controls. */
export function ImageValidationRenderingProvider({ children }: { readonly children: ReactNode }): JSX.Element {
    const freeEnabled = useSyncExternalStore(subscribeFreeImageRoutingRoots, hasFreeImageRouting, () => false);
    const [enabled] = useFeatureSettings(["imageValidationClient"]);
    return (
        <FreeImageRoutingRenderingContext.Provider value={freeEnabled}>
            <ImageValidationRenderingContext.Provider value={enabled}>
                {children}
            </ImageValidationRenderingContext.Provider>
        </FreeImageRoutingRenderingContext.Provider>
    );
}
